/* eslint-disable camelcase */
import React from 'react';
import Button from '../Button';
import BlockComponentTitle from '../BlockComponent/BlockComponentTitle';
import Dropdown from '../Dropdown';

const kernelLangList = ['Python 3', 'R', 'SageMath', 'Julia'];
// KERNEL_CONFIG_LIST keys must be kept in sync with
// minerva-ops/terraform/cluster_setup/production_jupyterhub/helm_values.yaml
export const DEFAULT_CODE_KERNEL_CONFIG = 'Small';
export const KERNEL_CONFIG_LIST = {
  Small: {
    title: 'Default',
    resources: '384MB RAM',
    description: 'Suitable for most coding tasks',
  },
  Large: {
    title: 'Large',
    resources: '1GB RAM',
    description: 'For tasks that require more memory',
  },
  HighMemory: {
    title: 'High-memory',
    resources: '7GB RAM',
    description: 'Only use for extremely memory-intensive tasks',
  },
};

export const KernelLang = (props) => {
  const {
    etc: {
      setFieldValue,
      values: { uuid, kernel_language },
    },
    locked,
  } = props;

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <BlockComponentTitle name="title">Language</BlockComponentTitle>

      <Dropdown>
        {({ isActive, toggle }) => (
          <>
            <Button
              type="button"
              disabled={locked}
              secondary
              onClick={toggle}
              data-cy="add-block"
              style={{ textAlign: 'left', minWidth: '150px' }}
            >
              <span
                style={{
                  marginLeft: '4px',
                }}
              >
                {kernel_language || kernelLangList[0]} ▾
              </span>
            </Button>
            <div style={{ position: 'relative' }}>
              <ul style={{ display: isActive ? 'block' : 'none' }}>
                {kernelLangList.map((lang) => {
                  const onClick = () => {
                    setFieldValue('kernel_language', lang);
                    toggle();
                  };
                  return (
                    <li
                      key={lang}
                      onClick={onClick}
                      data-cy={`select-lang-${lang}`}
                    >
                      {lang}
                    </li>
                  );
                })}
              </ul>
            </div>
          </>
        )}
      </Dropdown>
    </div>
  );
};

export const KernelConfig = (props) => {
  const {
    etc: {
      setFieldValue,
      values: { uuid, kernel_config },
    },
    locked,
  } = props;

  const kernelDisplay =
    KERNEL_CONFIG_LIST[kernel_config] ||
    KERNEL_CONFIG_LIST[DEFAULT_CODE_KERNEL_CONFIG];
  const { title: kernelDisplayTitle, resources: kernelResourceTitle } =
    kernelDisplay;

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <BlockComponentTitle name="title">
        Resource Configuration
      </BlockComponentTitle>

      <Dropdown>
        {({ isActive, toggle }) => (
          <>
            <Button
              type="button"
              secondary
              disabled={locked}
              onClick={toggle}
              data-cy="add-block"
              style={{ textAlign: 'left', minWidth: '300px' }}
            >
              <span
                style={{
                  marginLeft: '4px',
                }}
              >
                {`${kernelDisplayTitle}: ${kernelResourceTitle}`} ▾
              </span>
            </Button>
            <div style={{ position: 'relative' }}>
              <ul style={{ display: isActive ? 'block' : 'none' }}>
                {Object.keys(KERNEL_CONFIG_LIST).map((key) => {
                  const { title, resources, description } =
                    KERNEL_CONFIG_LIST[key];
                  const onClick = () => {
                    setFieldValue('kernel_config', key);
                    toggle();
                  };
                  return (
                    <li
                      key={key}
                      onClick={onClick}
                      data-cy={`select-lang-${key}`}
                      style={{ margin: '5px 0px' }}
                    >
                      <b>{`${title}: `}</b>
                      {resources}
                      <div style={{ fontStyle: 'italic', fontSize: 'small' }}>
                        {description}
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </>
        )}
      </Dropdown>
    </div>
  );
};
